import { Component, Inject, Injector } from '@angular/core';

import { CommonAppDataService } from '../../../Common/app_data/app_data.service';
import { CommonBaseComponent } from '../../../Common/base_component/base.component';

import { AuthenticationErrorService } from './services/authentication_error.service';
import { commonConstants } from '@CaseOne/Common/constants/common.constants';
import { COMMON_DOWNLOAD_IMAGE_SIZES } from '@CaseOne/Common/constants/common-download-image-sizes.constant';
import { WINDOW } from '@ng-web-apis/common';

@Component({
	selector: 'authentication-app',
	templateUrl: './authentication.component.pug',
	styleUrls: ['./authentication.component.sass'],
	providers: [
		AuthenticationErrorService,
	],
})

export class AuthenticationComponent extends CommonBaseComponent {
	appData: any;
	logoImageUrl: string;

	constructor (
		commonAppDataService: CommonAppDataService,
		protected injector: Injector,
		@Inject(WINDOW) private window: Window,
	) {
		super(injector);

		this.appData = commonAppDataService.getData();

		if (this.appData.CustomLogo?.AuthPageImage) {
			const imageId = this.appData.CustomLogo.AuthPageImage.Id;

			let height = COMMON_DOWNLOAD_IMAGE_SIZES.SIZE_40_NO_WIDTH.HEIGHT;

			if (this.window.devicePixelRatio > 1) {
				height *= 2;
			}

			this.logoImageUrl = `${commonConstants.publicDownload}?id=${imageId}&height=${height}`;
		}
	}
}
